import React from 'react';
import './kick-start.css';

const m_wywl = () => {
    const state = {
        wywl_item: [
            {
                text: `Deep Learning`,
            },
            {
                text: `Machine Learning`,
            },
            {
                text: `Artificial Intelligence`,
            },
            {
                text: `Text Analytics`,
            },
            {
                text: `Data Wrangling`,
            },
            {
                text: `Predictive Analytics`,
            },
            {
                text: `Machine Vision`,
            },
            {
                text: `Voice AI`,
            },
            {
                text: `Python for Data Science`,
            },
            {
                text: `R & Julia`,
            },
            {
                text: `Apache Spark, MLlib`,
            },
            {
                text: `Scikit-learn, Azure ML, Amazon ML, H20.ai`,
            },
            {
                text: `Tensorflow, Caffe, CNTK, Torch`,
            },
            {
                text: `Data Visualization`,
            },
            {
                text: `Neo4J, D3.js, R-Shiny`,
            },
      ],
    };

    const renderWYWL = (item, i) => {
        return (
            <div className="m_wywl_item">
                <p className="m_wywl_text inner_pages--text">{item.text}</p>
            </div>
        );
    };

    return (
        <div className="m_wywl__wrap">
            <div className="m_wywl container">
                <h3 className="m_wywl--title">What You’ll Learn</h3>
                <p className="m_learning--text inner_pages--text">Data science has many focus areas. The goal of this track is to accelerate your knowledge of data science by offering a series of introductory level training sessions, talks, and workshops on the most important tools and topics to help you quickly gain essential data science skills.</p>
                <div className="m_wywl_blocks">
                    {state.wywl_item.map((item, i) => renderWYWL(item, i))}
                </div>
            </div>
        </div>
    );
};

export default m_wywl;